import { AxiosResponse } from 'axios';
import { BaseService } from '@services/route.service';
import IService from '@types_main/iservice';
import { PagedResponse } from '@types_main/paged-response';
import { PagedParams } from '@types_main/paged.params';
import { TagRequest } from './requests/tag.request';
import { TagResponse } from './responses/tag.response';

export class TagService extends BaseService implements IService<TagResponse> {
    protected get resourceName(): string {
        return 'crm/tags';
    }

    public async getAll(
        filter?: string,
        params?: PagedParams
    ): Promise<AxiosResponse<PagedResponse<TagResponse>>> {
        return await this.get<PagedResponse<TagResponse>>('paginated' + (filter ?? ''), params);
    }

    public async getList(): Promise<AxiosResponse<{ data: TagResponse[] }>> {
        return await this.get('');
    }

    public async getById(id: string): Promise<AxiosResponse<{ data: TagResponse }>> {
        return await this.get(id);
    }

    public async create(body: TagRequest): Promise<AxiosResponse<{ data: TagResponse }>> {
        return await this.post(body);
    }

    public async update(id: string, body: TagRequest): Promise<AxiosResponse<{ data: TagResponse }>> {
        return await this.put(id, body);
    }

    public async deleteById(id: string): Promise<AxiosResponse<void>> {
        return await this.delete(id);
    }
}
